import moment from "moment";

export const capitalize = (str: string): string => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const errorMessageHandler = (err: any, defaultMsg = "Something went wrong!!!"): string => {
    const errorMessage = err?.data?.errors?.[0] || err?.data?.message || err.errors?.[0] || err?.message || defaultMsg;
    return errorMessage;
}

export const normalizeEmail = (email: string): string => email.trim().toLowerCase();

export const getInvalidEmails = (emails: string[]): string[] => {
    const EMAIL_REGEX = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
    return emails.filter(email => !EMAIL_REGEX.test(normalizeEmail(email)));
}

export const joinItems = (items?: string | string[], joiner = ', '): string => {
    if (!items || (Array.isArray(items) && items.length === 0)) return '-';
    return Array.isArray(items) ? items.join(joiner) : items;
};


export const formatDateTime = (
    input: string | null | undefined,
    format = "MM/DD/YYYY hh:mm A",
    fallback = " "
): string => {
    try {
        if (!input) return fallback;

        // Supported input formats
        const formats = [
            moment.ISO_8601,     // full date-time (API standard)
            "YYYY-MM-DD",        // date only
            "MM/DD/YYYY",        // fallback date
            "HH:mm:ss",          // time only
            "HH:mm",             // short time
        ];

        const m = moment(input, formats, true);

        if (!m.isValid()) return fallback;

        return m.format(format);
    } catch (err) {
        console.error("DateTime format error:", err);
        return fallback;
    }
};